import { Card, Flex } from 'antd';
import Title from 'antd/es/typography/Title';

import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { getServerInfo } from '@/adapters/misc';
import { IServerInfoRes } from '@/interfaces/misc';
import MasterMenu from './_components/master-menu';
import { useState } from 'react';
import BrandPage from '../master/brand';
import CatalogPage from '../master/catalog';
import ProductPage from '../product';
import StockPage from '../stock';
import OrderPage from '../order';

const MaterPage: React.FC = () => {
  const { data: serverInfo } = useQuery<AxiosResponse<IServerInfoRes>, Error>({
    queryKey: ['search-server-info'],
    queryFn: async () => await getServerInfo(),
  });

  const [key, setKey] = useState('brand');

  return (
    <>
      <Flex justify="space-between" gap={2}>
        <div>
          <Title level={2} className="text-center">
            {serverInfo?.data?.data?.[0]?.SERVER_NAME}
          </Title>
        </div>
        <div>
          <Title level={2} className="text-center">
            BENTO SERVICES (1.0.4)
          </Title>
        </div>
      </Flex>
      <Card className="mt-3">
        <MasterMenu onchange={e => setKey(e as string)} />
        <div className="flex p-3 w-full">
          {key === 'brand' && <BrandPage />}
          {key === 'catalog' && <CatalogPage />}
          {key === 'product' && <ProductPage />}
          {key === 'stock' && <StockPage />}
          {key === 'order' && <OrderPage />}
        </div>
      </Card>
    </>
  );
};

export default MaterPage;
